(() => {
  "use strict";

  // Plume Care: automatic free bowl promotion
  // Ends October 19, 2026 at 11:59 PM Hong Kong time.

  const GIFT_VARIANT_ID = 51975531888928;
  const END_TIME = Date.parse("2026-10-19T23:59:59+08:00");
  const GIFT_MARKER = "_plume_auto_gift";
  const CART_ROOT = window.Shopify?.routes?.root || "/";

  // Names of the five qualifying products.
  const QUALIFYING_PRODUCTS = [
    "honey oat",
    "the new pawrent set",
    "the daily soothe, clean",
    "the after walkie routine",
    "the bath ritual set"
  ];

  const nativeFetch = window.fetch.bind(window);
  let busy = false;
  let timer;
  let reloadPending = false;

  function qualifies(item) {
    const title = (item.product_title || "")
      .toLowerCase()
      .trim();

    return QUALIFYING_PRODUCTS.some(name =>
      title.includes(name)
    );
  }

  function isGift(item) {
    return (
      String(item.variant_id) === String(GIFT_VARIANT_ID) &&
      item.properties?.[GIFT_MARKER] === "yes"
    );
  }

  async function cartRequest(path, data) {
    const response = await nativeFetch(CART_ROOT + path, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error("Cart update failed");
    }

    return response.json();
  }

  async function syncGift() {
    if (busy || reloadPending) return;
    busy = true;

    try {
      const response = await nativeFetch(
        CART_ROOT + "cart.js",
        { credentials: "same-origin", cache: "no-store" }
      );

      if (!response.ok) return;

      const cart = await response.json();
      const items = cart.items || [];

      const validDate = Date.now() <= END_TIME;
      const hasQualifyingProduct =
        items.some(qualifies);

      const giftedItem = items.find(isGift);

      const anyBowl = items.some(item =>
        String(item.variant_id) === String(GIFT_VARIANT_ID)
      );

      let changed = false;

      if (!validDate || !hasQualifyingProduct) {
        if (giftedItem) {
          await cartRequest("cart/change.js", {
            id: giftedItem.key,
            quantity: 0
          });
          changed = true;
        }
      } else if (!anyBowl) {
        await cartRequest("cart/add.js", {
          items: [{
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: {
              [GIFT_MARKER]: "yes"
            }
          }]
        });
        changed = true;
      } else if (giftedItem && giftedItem.quantity > 1) {
        await cartRequest("cart/change.js", {
          id: giftedItem.key,
          quantity: 1
        });
        changed = true;
      }

      // Refresh the page to display the updated cart.
      if (changed) {
        reloadPending = true;
        window.location.reload();
      }

    } catch (error) {
      console.warn("Plume free gift:", error);
    } finally {
      busy = false;
    }
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(syncGift, 600);
  }

  // Detect cart updates made through Shopify's Ajax API.
  window.fetch = function (...args) {
    const result = nativeFetch(...args);
    const request = args[0];
    const url =
      typeof request === "string"
        ? request
        : request?.url || "";

    const method = (
      args[1]?.method ||
      request?.method ||
      "GET"
    ).toUpperCase();

    if (
      method === "POST" &&
      /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)
    ) {
      result.then(response => {
        if (response.ok) scheduleSync();
      }).catch(() => {});
    }

    return result;
  };

  // Check when the storefront loads and when revisited.
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded", scheduleSync
    );
  } else {
    scheduleSync();
  }

  window.addEventListener("pageshow", scheduleSync);

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) scheduleSync();
  });
})();